export function safeStringify(obj: unknown, maxLength = 500) {
    try {
        const str = JSON.stringify(obj)
        return str.length > maxLength ? str.slice(0, maxLength) + '...[truncated]' : str
    } catch {
        return '[Unserializable object]'
    }
}

/**
 * 把不同类型都转为 Error 实例
 * @param err
 * @returns
 */
export default function normalizeError(err: unknown): Error {
    if (err instanceof Error) {
        return err // 直接返回 Error 实例
    }

    if (typeof err === 'string') {
        return new Error(err) // 字符串转换为 Error
    }

    if (typeof err === 'object' && err !== null) {
        // eslint-disable-next-line jst-gyl/disable-empty-catch
        try {
            if (typeof err === 'object' && err !== null) {
                return new Error(safeStringify(err))
            }
        } catch (e) {
            return new Error('Unknown error object')
        }
    }

    return new Error('Unknown error') // 其他情况，如 null、undefined、数字等
}
